/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { signUp } from '../../../data/store/user/userActions';
import {
  confirmPassRules,
  emailRules,
  nameRules,
  passwordRules
} from '../../../helpers/validation';
import { Form, Input, Row, Radio, Space, Divider, Button, Col } from 'antd';
import CustomCheckbox from '../../CustomCheckbox/CustomCheckbox';

import { ReactComponent as Arrow } from '../../../assets/arrow-up-right.svg';

import PropTypes from 'prop-types';
import CustomPasswordInput from '../../CustomPasswordInput/CustomPasswordInput';
import './style.scss';
import CustomRadioButton from '../../CustomRadioButton/CustomRadioButton';

const SignUpForm = ({theme}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('');
  const [form] = Form.useForm();
  const [, forceUpdate] = useState({});
  const [type, setType] = React.useState('ADVISER');

  const accountType = Form.useWatch('role', form);

  const handleValueChange = async () => {

  };

  const handleTermClick = () => {
    console.log('Terms');
  };

  const onChangeType = (e) => {
    setType(e.target.value);
  };

  const onSubmit = useCallback((fields) => {
    dispatch(signUp({ ...fields }));
  }, [dispatch]);

  // To disable submit button at the beginning.
  useEffect(() => {
    forceUpdate({});
  }, []);

  return (
    <Row className='sign-up-form-wrapper'>
      <Form
        form={form}
        name="sign-up-form"
        layout="vertical"
        onFinish={onSubmit}
        className='sign-up-form'>
        <Row
          justify={'space-between'}
          align={'middle'}
          className='sign-up-form-check-wrap'>
          <Col>
            <h2 className='sign-up-lable-radio'>{t('ROLE')}</h2>
          </Col>
          <Col>
            <Form.Item
              name="role"
              required={false}
              className='custom-required radio-acc-type'>
              <Radio.Group onChange={onChangeType} value={type} className=''>
                <Space direction="horizontal">
                  <CustomRadioButton 
                    className={'client-signup'}
                    value="CLIENT">{t('CLIENT')}</CustomRadioButton>
                  <CustomRadioButton 
                    className={'client-signup'}
                    value="ADVISER">{t('ADVISOR')}</CustomRadioButton>
                </Space>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        {accountType === 'CLIENT'
          ? (
              <Row>
                <Col span={24}>
                  <p className='sign-up-note'>{t('SIGN_UP_NOTE_CLIENT')}</p>
                </Col>
              </Row>
            )
          : accountType === 'ADVISER'
            ? (
                <Row>
                  <Col span={24}>
                  <p className='sign-up-note'>{t('SIGN_UP_NOTE_ADVISOR')}</p>
                  </Col>
                </Row>
              )
            : null
        }
        <Divider className='login-divider'/>
        <div className="sign-up-wrapper">
          <Form.Item
            label={t('FIRST_NAME')}
            name="first_name"
            rules={nameRules}
            required={false}
            className='custom-required'
            >
            <Input
              className='login-input custom-input'
              placeholder={t('FIRST_NAME')} />
          </Form.Item>

          <Form.Item
            label={t('LAST_NAME')}
            name="last_name"
            rules={nameRules}
            required={false}
            className='custom-required'
          >
            <Input
              className='login-input custom-input'
              placeholder={t('LAST_NAME')} />
          </Form.Item>
        </div>

        <div className="sign-up-wrapper">
          <Form.Item
            label={t('EMAIL')}
            name="email"
            rules={emailRules}
            required={false}
            className='custom-required'
          >
            <Input
              key={theme}
              className='custom-input'
              placeholder={t('EMAIL')}
              />
          </Form.Item>
        </div>
        {accountType === 'CLIENT' &&
          <div className="sign-up-wrapper">
          <Form.Item
            label={t('REGISTRATION_CODE')}
            name="registration_code"
            rules={[{
              required: true,
              message: `${t('REGISTRATION_CODE')}`,
            }]}
            required={false}
            className='custom-input'
          >
            <Input
              className='login-input custom-input'
              placeholder={t('REGISTRATION_CODE')}
              />
          </Form.Item>
        </div>}

        <div className="sign-up-wrapper">
          <Form.Item
            label={t('PASSWORD')}
            name="password"
            rules={passwordRules}
          >
            <CustomPasswordInput
              key={theme}
              placeholder={t('PASSWORD')}
              className='login-input pass'
              onChange={handleValueChange}
              autoComplete="new-password"
              />
          </Form.Item>

          <Form.Item
            label={t('CONFIRM_PASSWORD')}
            name="passwordConfirm"
            dependencies={['password']}
            rules={confirmPassRules}
          >
            <CustomPasswordInput
              key={theme}
              placeholder={t('CONFIRM_PASSWORD')}
              className='login-input pass'
              onChange={handleValueChange}
              autoComplete="new-password"
              />
          </Form.Item>
        </div>
        <div>
            <Row justify={'center'} style={{marginBottom: '20px'}}>
              <Button
                type='text'
                className='forgor-btn'
                icon={<Arrow/>}
                iconPosition={'end'}
                onClick={handleTermClick}
              >
                {t('TERM_AND_CONDITIONS')}
              </Button>
            </Row>
              <Form.Item name="agreement" valuePropName="checked" required={true}>
                <CustomCheckbox
                  className='agreement-check'
                  onChange={handleValueChange}>
                  {t('AGREEMENT_TEXT')}
                </CustomCheckbox>
              </Form.Item>
          </div>

        <Form.Item shouldUpdate>
          {() => (
            <Button
              type='submit'
              className='signup-submit-btn'
              onClick={() => form.submit()}
              disabled={
                // !form.isFieldsTouched(true) ||
                !!form.getFieldsError().filter(({ errors }) => errors.length).length ||
                !form.getFieldValue('agreement')
              }
            >
              {t('REGISTER')}
            </Button>
          )}
        </Form.Item>

      </Form>
    </Row>
  );
};

export default SignUpForm;

SignUpForm.propTypes = {
  theme: PropTypes.string,
};